import React, { createContext, useContext } from "react";
import { Control } from "react-hook-form";
import { AdministerMedicationRequest } from "app/services/api/types/medications/requests/AdministerMedicationRequest";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";

interface MedicationModalContextType {
  control: Control<AdministerMedicationRequest>;
  isSubmitting: boolean;
  medication?: MedicationModel;
}

const MedicationModalContext = createContext<
  MedicationModalContextType | undefined
>(undefined);

export const useMedicationModal = () => {
  const context = useContext(MedicationModalContext);
  if (context === undefined) {
    throw new Error(
      "useMedicationModal must be used within a MedicationModalProvider",
    );
  }
  return context;
};

export const MedicationModalProvider = MedicationModalContext.Provider;
